module.exports = __webpack_public_path__ + "img/home-pic-10.a0311513.jpg";